import { Injectable, EventEmitter } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  private drawer: MatDrawer;
  private drawerS: MatDrawer;
  private qrData: any;
  preparePrint = new EventEmitter();
  isLoader = new EventEmitter();
  currentDate = new Date();

  volume = new BehaviorSubject(1);
  sound = new BehaviorSubject(true);

  constructor() { }

  setDrawer(drawer: MatDrawer) {
    this.drawer = drawer;
  }

  setDrawerSettings(drawer: MatDrawer) {
    this.drawerS = drawer;
  }

  toggle(): void {
    this.drawer.toggle();
  }

  toggleSettings(): void {
    this.drawerS.toggle();
  }

  toggleLoader(isLoading: boolean): void {
    this.isLoader.emit(isLoading);
  }

  setQrData(qrData) {
    this.qrData = qrData;
  }

  getQrData() {
    return this.qrData;
  }

  prepare() {
    this.preparePrint.emit();
  }

  addTimeToDate(date: Date, time: any) {
    let hoursArray = time.split(':');
    date.setHours(hoursArray[0], hoursArray[1], hoursArray[1]);
    return date;
  }

  addCurrentTimeToDate(date: Date) {
    let currentDate = new Date;
    date.setHours(currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds());
    return date;
  }

  isDateDisabledTo(object: any) {
    let res = false;
    if (object && object.availabilities && object.availabilities.length > 0) {
      let objDate = object.availabilities[0].disabledTo;
      let dateS = objDate.iso ? new Date(objDate.iso) : new Date(objDate);
      if (this.currentDate.getTime() < dateS.getTime()) {
        res = true;
      }
    }
    return res;
  }

  getWhatsappURL(phone: string, message: string) {
    if (!phone.startsWith('+') && !phone.startsWith('591')) {
      // add internacional prefix
      phone = '591' + phone;
    }
    return `https://wa.me/${phone.replace(/[^0-9]/ig, '')}?text=${encodeURI(message)}`;
  }

  getPreparationZones(orderItems) {
    let preparationZones = [];
    if (orderItems && orderItems.length > 0) {
      orderItems.forEach(item => {
        let pZArray = preparationZones.filter(pZ => pZ.name === item.preparationZone);
        if (pZArray.length > 0) {
          const index = preparationZones.indexOf(pZArray[0]);
          preparationZones[index].items.push(item);
        } else {
          preparationZones.push({name: item.preparationZone, items: [item]});
        }
      });
    }

    return preparationZones;
  }

  setImageSize(image: string, size: any) {
    let img = image.split('.');
    let index = img.length - 2;
    if (index > 0) {
      switch (size) {
        case 200:
          img[index] = img[index] + '_thumb_0x200';
          break;
        case 280:
          img[index] = img[index] + '_thumb_280x0';
          break;
        case 60:
          img[index] = img[index] + '_thumb_60x60';
          break;

        default:
          break;
      }
    }
    return img.join('.');
  }
}
